import { render, staticRenderFns } from "./SendingDomains.vue?vue&type=template&id=3d712e5a&"
import script from "./SendingDomains.vue?vue&type=script&lang=js&"
export * from "./SendingDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports